import { Component, OnInit } from '@angular/core';
import { AlertService, MessageType } from '../../../../services/alert.service';
import { MatDialog } from '@angular/material/dialog';
import { ExtendedTableComponent } from '../../../../helpers/extended-management';
import { ServerManagementService, ConsoleService } from '../../../../api/api';
import * as momentjs from 'moment';

@Component({
  selector: 'app-logger-console',
  templateUrl: './logger-console.component.html',
  styleUrls: ['./logger-console.component.scss']
})
export class LoggerConsoleComponent extends ExtendedTableComponent implements OnInit {

  displayedColumns = ['date', 'type', 'message'];
  loading = true;

  public moment = momentjs;

  constructor(
    private alertService: AlertService,
    private consoleService: ConsoleService,
    private dialog: MatDialog
  ) {
    super();
  }

  reloadData() {
    this.consoleService.getAll().subscribe(result => {
      this.moment.locale('pl');
      this.updateTableData(result.reverse());
      this.loading = false;
    }, error => console.error(error));
  }

  clear(){
    this.consoleService.deleteAll().subscribe(res => {
      this.alertService.showMessage('Pomyślnie wyczyszczono dziennik zdarzeń', MessageType.Info);
    }, error => {
      this.alertService.showMessage('Błąd podczas wykonywania operacji', MessageType.Info);
      console.log(error.error);
    });
  }

  ngOnInit() {
    this.reloadData();
  }
}